import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';
import { EmployeeShopsState } from '../reducers/employeeShops';

const getStoreSelector = (state: TSFixMe) => state.employeeShops as EmployeeShopsState;

export const getStore = createSelector(getStoreSelector, employeeShops => ({
  ...employeeShops,
  shops:
    employeeShops.shops.length > 1 ? sortBy(employeeShops.shops, ['name']) : employeeShops.shops,
}));
